import { LocationVarKey } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetLayout, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { WorksheetComponent, WorksheetComponentType } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.OfficeHours,
  LocationVarKey.AccessHours,
  LocationVarKey.CallCenterHours,
  LocationVarKey.SpecialHours
];

export default function LocationSubpageHours() {
  const page = usePropertiesGetLocationIds();

  return (
    <WorksheetLayout>
      <h4>Hours</h4>
      <WorksheetRow>
        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Location Hours"
            keyName={LocationVarKey.OfficeHours}
          />
          <WorksheetComponent componentType={WorksheetComponentType.MULTI_LINE} {...page} label="Access Hours" keyName={LocationVarKey.AccessHours} />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Call Center Hours"
            keyName={LocationVarKey.CallCenterHours}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.MULTI_LINE}
            {...page}
            label="Holiday & Special Hours"
            keyName={LocationVarKey.SpecialHours}
          />
        </WorksheetColumn>
      </WorksheetRow>
    </WorksheetLayout>
  );
}
